// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hamberger-container {
  height: 50px;
  width: 50px;
  background-color: transparent;
  float: right;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 3px;
  position: fixed;
  right: 20px;
  top: 20px;
  cursor: pointer;
  border: 0;
}
.hamberger-patch {
  height: 200px;
  width: 200px;
  background-color: var(--app-color-4);
  position: fixed;
  right: -80px;
  top: -80px;
  border-radius: 50%;
}

.hamberger-bar,
.hamberger-bar-tilt-1,
.hamberger-bar-tilt-2,
.hamberger-bar-tilt-3 {
  background-color: var(--app-color-4);
  width: 100%;
  height: 10%;
  border-radius: 10px;
  margin: auto;
  transform-origin: left;
  transition: transform 0.1s ease-in-out;
}

.hamberger-bar {
  background-color: black;
}

.hamberger-bar-tilt-1 {
  transform-origin: left;
  transform: scale(1.2) translateX(4%) rotate(45deg);
  transition: transform 0.1s ease-in-out;
}

.hamberger-bar-tilt-2 {
  visibility: hidden;
  transition: visibility 0.1s ease-in-out;
}

.hamberger-bar-tilt-3 {
  transform-origin: left;
  transform: scale(1.2) translateX(4%) rotate(-45deg);
  transition: transform 0.1s ease-in-out;
}

@media screen and (min-width: 1300px) {
  .hamberger-container, .hamberger-patch {
    visibility: hidden;
  }
}

@media screen and (max-width: 800px) {
  .hamberger-patch {
    width: 170px;
    height: 170px;
    top: -70px;
    right: -70px;
  }
}

@media screen and (max-width: 500px) {
  .hamberger-container {
    height: 25px;
    width: 30px;
    top: 15px;
    right: 15px;
  }
  .hamberger-bar-tilt-1,
  .hamberger-bar-tilt-3 {
    transform-origin: left;
    transition: transform 0.1s ease-in-out;
  }
  .hamberger-bar-tilt-1 {
    transform: scale(1.35) translateX(4%) rotate(45deg);
  }
  .hamberger-bar-tilt-3 {
    transform: scale(1.35) translateX(4%) rotate(-45deg);
  }
  .hamberger-patch {
    width: 130px;
    height: 130px;
    top: -60px;
    right: -60px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Hamberger/Hamberger.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,SAAS;EACT,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;EAIE,oCAAoC;EACpC,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,mDAAmD;EACnD,sCAAsC;AACxC;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;EACb;EACA;;IAEE,sBAAsB;IACtB,sCAAsC;EACxC;EACA;IACE,mDAAmD;EACrD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,YAAY;IACZ,aAAa;IACb,UAAU;IACV,YAAY;EACd;AACF","sourcesContent":[".hamberger-container {\r\n  height: 50px;\r\n  width: 50px;\r\n  background-color: transparent;\r\n  float: right;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-around;\r\n  border-radius: 3px;\r\n  position: fixed;\r\n  right: 20px;\r\n  top: 20px;\r\n  cursor: pointer;\r\n  border: 0;\r\n}\r\n.hamberger-patch {\r\n  height: 200px;\r\n  width: 200px;\r\n  background-color: var(--app-color-4);\r\n  position: fixed;\r\n  right: -80px;\r\n  top: -80px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.hamberger-bar,\r\n.hamberger-bar-tilt-1,\r\n.hamberger-bar-tilt-2,\r\n.hamberger-bar-tilt-3 {\r\n  background-color: var(--app-color-4);\r\n  width: 100%;\r\n  height: 10%;\r\n  border-radius: 10px;\r\n  margin: auto;\r\n  transform-origin: left;\r\n  transition: transform 0.1s ease-in-out;\r\n}\r\n\r\n.hamberger-bar {\r\n  background-color: black;\r\n}\r\n\r\n.hamberger-bar-tilt-1 {\r\n  transform-origin: left;\r\n  transform: scale(1.2) translateX(4%) rotate(45deg);\r\n  transition: transform 0.1s ease-in-out;\r\n}\r\n\r\n.hamberger-bar-tilt-2 {\r\n  visibility: hidden;\r\n  transition: visibility 0.1s ease-in-out;\r\n}\r\n\r\n.hamberger-bar-tilt-3 {\r\n  transform-origin: left;\r\n  transform: scale(1.2) translateX(4%) rotate(-45deg);\r\n  transition: transform 0.1s ease-in-out;\r\n}\r\n\r\n@media screen and (min-width: 1300px) {\r\n  .hamberger-container, .hamberger-patch {\r\n    visibility: hidden;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 800px) {\r\n  .hamberger-patch {\r\n    width: 170px;\r\n    height: 170px;\r\n    top: -70px;\r\n    right: -70px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n  .hamberger-container {\r\n    height: 25px;\r\n    width: 30px;\r\n    top: 15px;\r\n    right: 15px;\r\n  }\r\n  .hamberger-bar-tilt-1,\r\n  .hamberger-bar-tilt-3 {\r\n    transform-origin: left;\r\n    transition: transform 0.1s ease-in-out;\r\n  }\r\n  .hamberger-bar-tilt-1 {\r\n    transform: scale(1.35) translateX(4%) rotate(45deg);\r\n  }\r\n  .hamberger-bar-tilt-3 {\r\n    transform: scale(1.35) translateX(4%) rotate(-45deg);\r\n  }\r\n  .hamberger-patch {\r\n    width: 130px;\r\n    height: 130px;\r\n    top: -60px;\r\n    right: -60px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
